import {Component} from '@angular/core';
import {Router} from '@angular/router';
import { TRAINING } from '../../app.constants';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {

  activeMenu = 'home';
  trainingSystem = TRAINING;
  constructor(private router: Router
  ) {

  }

  changeMenu(menu: string, destination: string) {
    this.activeMenu = menu;
    this.router.navigateByUrl(destination);
  }
}



// WEBPACK FOOTER //
// ./src/app/layouts/footer/footer.component.ts